import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CModalRecordVideoComponent } from './c-modal-record-video.component';
import { TimeFormatPipe } from 'src/app/pipes/time-format/time-format.pipe';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TimeFormatPipe
  ],
  declarations: [CModalRecordVideoComponent],
  exports: [CModalRecordVideoComponent]
})
export class CModalRecordVideoModule { }
